export class ChatStarters {
    constructor(
        public starters: ChatStarter[]
    ) { }
}

export class ChatStarter {
    constructor(
        public type: ChatStarterType,
        public name: string,
        public processId: number = null,
        public formId: number = null,
        public definitionId: number = null,
        public issueTemplateId: number = null,
        public issueContentType: IssueContentType = null
    ) { }
}

export enum ChatStarterType { 
	Form = 1,
	Process = 2,
    Definition = 3,
    IssueTemplate = 4
}

export enum IssueContentType {
    Message = 1,
    Ticket = 2,
    Mission = 3,
    DirectMessage = 7,
    Order = 8
}
